import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export type LiftSelectProps<T> = {
  value: T;
  onChange: (selectedLift: T) => void;
  options: { value: T; name: string }[];
};

export const LiftSelect = <T extends string>(props: LiftSelectProps<T>) => {
  return (
    <FormControl>
      <InputLabel id="lift-select-label">Lift Type</InputLabel>
      <Select
        fullWidth
        labelId="lift-select-label"
        value={props.value}
        onChange={e => props.onChange(e.target.value as T)}
        size="small"
        label="Lift Type"
      >
        {props.options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
